<div class="emperor-message-alert-container">
  <emperor-alert
    [uiAlertType]="messageLevelToUiAlertType(message.level)"
    icon="interface_information"
  >
    {{ message.target }}
  </emperor-alert>
</div>
